/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./UnauthorizedLayout.vue?vue&type=template&id=f6857ff8"
import script from "./UnauthorizedLayout.vue?vue&type=script&lang=ts"
export * from "./UnauthorizedLayout.vue?vue&type=script&lang=ts"
import style0 from "./UnauthorizedLayout.vue?vue&type=style&index=0&id=f6857ff8&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports